import { styled } from '@linaria/react';

import { colors, fonts, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${space[1]};
  min-height: 44px;
`;

export const Label = styled.label`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.normal};
  color: ${colors.fontSecondary};
`;

export const RequiredMark = styled.span`
  color: ${colors.error};
  margin-left: 2px;
`;

export const FieldError = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${colors.error};
`;
